import type { UseControllerProps } from "react-hook-form";
import { Controller, useFormContext } from "react-hook-form";
import type { ScorePickerComponentProps } from "./ScorePickerComponent";
import { ScorePickerComponent } from "./ScorePickerComponent";
import "./styles.scss";

export interface ScorePickerProps extends Partial<ScorePickerComponentProps> {
  name: string;
  rules?: UseControllerProps["rules"];
}

export const ScorePicker = ({
  name,
  rules,
  ...passThroughProps
}: ScorePickerProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value } }) => (
        <ScorePickerComponent
          {...passThroughProps}
          onChange={onChange}
          value={value}
        />
      )}
    />
  );
};

ScorePicker.displayName = "Form.ScorePicker";
